import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";

import { earlyPhases, phaseKey } from "./projectUtils";

export const PhaseBadge = ({ phase }: { phase?: string | null }) => {
  const translate = useTranslate();
  if (!phase) return null;
  return (
    <Badge
      variant="outline"
      className={
        // Phase amont, celle qui compte pour la prescription : cadre d'encre. Le vert reste au seul tampon « Sourcé ».
        earlyPhases.includes(phase)
          ? "border-foreground/60"
          : "text-muted-foreground"
      }
    >
      {translate(phaseKey(phase), { _: phase })}
    </Badge>
  );
};
